import {ResponseStatus} from '@/utils/request';
import {ParamsProps} from '@/components/WdiBus/FormPage';
import {wdiCore, WdiModalAppResult} from '@/components/WdiControls';
import {FormApi} from '@/services/sales';
import {FormSaMkt} from '@/services/mkt/sa';
import {Enum} from '@/enums/system';
import DataStore from '@/components/GridWidget/DataStore';
import {BOHQ} from '@/services/mdm/bohq';

export type ViewEntityProps = {
  form?: API.Form,
  formSaMkt?: API.FormSaMktVo,
  relationType?: number,
  relatedFormId?: number,
  formId?: number;
  statusId?: number;
  formTypeId?: number;
  pageTypeId?: number;
  userId?: number;
  positionId?: number;
  bohqId?: number;
}

export const initApplyPageContext = async (params: ParamsProps) => {

  const result: WdiModalAppResult = {
    code: ResponseStatus.UNKNOWN,
  };

  const viewEntity: ViewEntityProps = {};

  viewEntity.formTypeId = params.formTypeId;
  viewEntity.pageTypeId = params.pageTypeId;
  viewEntity.bohqId = params.bohqId;

  if (params.formId) {
    //草稿
    const form = await FormApi.get(params.formId);
    viewEntity.form = form.data;
    const formSaMkt = await FormSaMkt.get(params.formId);
    viewEntity.formSaMkt = formSaMkt.data;
    viewEntity.statusId = viewEntity.form.statusId;
    viewEntity.formId = viewEntity.form.formId;
  } else if (params.relatedFormId) {
    //变更
    const form = await FormApi.get(params.relatedFormId);
    viewEntity.form = form.data;
    viewEntity.relatedFormId = viewEntity.form.formId;
    viewEntity.relationType = params.relationType;

    const formSaMkt = await FormSaMkt.get(params.relatedFormId);
    viewEntity.formSaMkt = formSaMkt.data;

    if (viewEntity.relationType == Enum.FormRelationType.REJECTED && viewEntity.form.statusId != Enum.FormStatus.REJECTED) {
      result.message = viewEntity.form.formNo + '单据不是退回待修改状态，无效的操作！';
      return result;
    }
    if (viewEntity.relationType == Enum.FormRelationType.MODIFIED && viewEntity.form.statusId != Enum.FormStatus.APPROVE_COMPLETED) {
      result.message = viewEntity.form.formNo + '单据不是审批完成状态，无效的操作！';
      return result;
    }
  }

  if (viewEntity.form) {
    if (!params.formTypeId) {
      viewEntity.formTypeId = viewEntity.form.formTypeId;
    }
    if (!params.pageTypeId) {
      viewEntity.pageTypeId = viewEntity.form.pageTypeId;
    }
    if (!params.userId) {
      viewEntity.userId = viewEntity.form.userId;
    }
    if (!params.positionId) {
      viewEntity.positionId = viewEntity.form.positionId;
    }
  }

  result.code = ResponseStatus.SUCCESS;
  result.data = viewEntity;
  return result;
};

export const initApprovalPageContext = async (params: ParamsProps) => {
  const result: WdiModalAppResult = {
    code: ResponseStatus.UNKNOWN,
  };
  const viewEntity: ViewEntityProps = {};
  if (params.formId) {
    const formSaMkt = await FormSaMkt.get(params.formId);
    viewEntity.formSaMkt = formSaMkt.data;
    if (!viewEntity.formSaMkt) {
      result.message = '无效的草稿单';
      return result;
    }

    const formResponse = await FormApi.get(params.formId);
    viewEntity.form = formResponse.data;
    const bohqRes = await BOHQ.get(viewEntity.formSaMkt.bohqId ?? 0);
    viewEntity.formSaMkt.bohqName = bohqRes.data.bohqName;
  }

  result.code = ResponseStatus.SUCCESS;
  result.data = viewEntity;
  return result;
};

export const addAllocateAmount = (dataSource: any[], detailDataSource: any[] | undefined, rateColumn: string) => {
  let allAmount = 0;
  if (detailDataSource && detailDataSource.length > 0) {
    detailDataSource.map(detail => {
      allAmount = wdiCore.Number.ToNumber(allAmount + detail.amount, 2);
    });
  }
  const newDataSource = [];
  let amountMonth = 0;
  if (dataSource && dataSource.length > 0) {
    let rate = 0;
    for (let i = 0; i < dataSource.length; i++) {
      const item = dataSource[i];
      const itemRate = item[rateColumn];
      rate = wdiCore.Number.ToNumber(rate + itemRate, 6);
      if (dataSource.length > 1 && rate === 1 && i == dataSource.length - 1) {
        item.amountMonth = wdiCore.Number.ToNumber(allAmount - amountMonth, 2);
        newDataSource.push(item);
      } else {
        item.amountMonth = wdiCore.Number.ToNumber(allAmount * itemRate, 2);
        amountMonth = wdiCore.Number.ToNumber(amountMonth + item.amountMonth, 2);
        newDataSource.push(item);
      }
    }
  }
  return DataStore.init(newDataSource);
};

export const buildRateMonth = (dataSource: any[]) => {
  const allAmount = wdiCore.Number.ToNumber(dataSource.reduce((total, item) => total + item.amountMonth, 0), 2);
  const newDataSource = [];
  if (dataSource && dataSource.length > 0) {
    let shareRate = 0;
    for (let i = 0; i < dataSource.length; i++) {
      const item = dataSource[i];
      if (i == dataSource.length - 1) {
        item.shareRate = wdiCore.Number.ToNumber(1 - shareRate, 6);
        newDataSource.push(item);
      } else {
        if (allAmount) {
          item.shareRate = wdiCore.Number.ToNumber(item.amountMonth / allAmount, 6);
        }
        shareRate = wdiCore.Number.ToNumber(shareRate + item.shareRate, 6);
        newDataSource.push(item);
      }
    }
  }
  return DataStore.init(newDataSource);
};


export const getFormStatusName = async (entity: ViewEntityProps) => {
  if (entity.form?.statusId === 2) {
    if (entity.formSaMkt?.isClosed) {
      return '已审批已关闭';
    } else {
      return '已审批未关闭';
    }
  } else {
    let formStatusName = '';
    switch (entity.formSaMkt?.statusId) {
      case 0:
        formStatusName = '草稿';
        break;
      case 1:
        formStatusName = '待审批';
        break;
      case 2:
        formStatusName = '已审批';
        break;
      case 3:
        formStatusName = '退回待修改';
        break;
      case 4:
        formStatusName = '作废';
        break;
    }
    return formStatusName;
  }
};
